import type { KpiCardSpec } from './card-spec';

/**
 * The lifetime downloads scalar, shown on the Overview featured row and the
 * Acquisition pulse row. One object spread into both catalogs, so the two
 * pages cannot report different figures for the same KPI.
 *
 * It replaced the trailing-90-days Downloads scalar (now removed): the fixed
 * window existed to dodge Apple's expiring report instances, and once the
 * lifetime journal shipped (`app-downloads-total`), a headline tile pinned to
 * an arbitrary 90 days answered no question the lifetime figure does not.
 */
export const ALL_TIME_DOWNLOADS_SCALAR_CARD: KpiCardSpec = {
    title: 'All-time downloads',
    source: 'app-downloads-total',
    form: 'number',
    metric: 'appDownloadsTotal',
    size: 'sm',
    description:
        'Installs of both apps since launch. The page Period does not move it: the endpoint echoes the requested window back but never queries it. Region resolves only down to a brand, and Circle K covers the whole rest of Canada as one pool, so the only selections it can serve are Quebec alone and every non-Quebec province together; anything else reads "Region not servable". Read it as a floor, not an exact count: it is counted from a journal that starts after each app launched.',
};
